import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ContentCard from "../../common/template/contentCard";
import ContentCardHeader from "../../common/template/contentCardHeader";
import ContentCardBody from "../../common/template/contentCardBody";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import Button from "../../common/button/button";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    getListaGraficoCustoTiposMultaAnual,
    getListaGraficoCustoMultaAnual,
    getListaGraficoCustoMultaAgrupado,
    getListaGraficoCustoReativoTipoMulta,
    getListaGraficoCustoMultaPorUnidadeAcumuladoAno,
    setFiltro,
} from "../analiseActions";
import { gerarRelatorio } from "../../fatura/faturaActions.js";

import { montarGraficoColumn } from "../../common/graficos/montarGraficoColumn.js";
import { montarGraficoPieAnual } from "../../common/graficos/montarGraficoPieAnual.js";
import { montarGraficoClusteredColumnGrupo } from "../../common/graficos/montarGraficoClusteredColumnGrupo.js";
import { montarGraficoHorizontalBar } from "../../common/graficos/montarGraficoHorizontalBar.js";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox.jsx";
import { setInfo } from "../../common/toast/toast.jsx";
import { convertToBase64 } from "../../utils/convertToBase64.js";
import { Loading } from "../../common/loading/loading.jsx";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";

function analiseMulta(props) {

    if(!props.visible) return null;
    
    const {
        state,
        listar,
        filtro,
        listaGraficoCustoTiposMulta,
        listaGraficoCustoMulta,
        listaGraficoCustoMultaAgrupado,
        listarGraficoCustoReativoTipoMulta,
        listaGraficoCustoMultaPorUnidade,
        getListaGraficoCustoTiposMultaAnual,
        getListaGraficoCustoMultaAnual,
        getListaGraficoCustoMultaAgrupado,
        getListaGraficoCustoReativoTipoMulta,
        getListaGraficoCustoMultaPorUnidadeAcumuladoAno,
        setAguardando,
        gerarRelatorio,
        setFiltro,
    } = props;

    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);
    const [graficoCustoTiposMultaAnual, setGraficoCustoTiposMultaAnual] = useState(null);
    const [graficoCustoMultaAnual, setGraficoCustoMultaAnual] = useState(null);
    const [graficoCustoMultaTipo, setGraficoCustoMultaTipo] = useState(null);
    const [graficoCustoReativoTipoMulta, setGraficoCustoReativoTipoMulta] = useState(null);
    const [graficoCustoAcumuladoAnualMultasPorUC, setGraficoCustoAcumuladoAnualMultasPorUC] = useState(null);

    useEffect(() => {
        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;

            await Promise.all([
                getListaGraficoCustoTiposMultaAnual(),
                getListaGraficoCustoMultaAnual(),
                getListaGraficoCustoMultaAgrupado(),
                getListaGraficoCustoReativoTipoMulta(),
                getListaGraficoCustoMultaPorUnidadeAcumuladoAno(),
            ]);

            setAguardando(false);
        };

        buscarDados();
        if (!state.aguardando) {
            atualizarTodosGraficos();
        }
    }, [state.aguardando]);

    function atualizarTodosGraficos() {
        atualizarListaGraficoCustoTiposMultaAnual();
        atualizarListaGraficoCustoMultaAnual();
        atualizarListaGraficoCustoMultaAgrupado();
        atualizarListaGraficoCustoReativoTipoMulta();
        atualizarListaGraficoCustoAcumuladoAnualMultasPorUC();
    }
    function desmontarTodosGraficos() {
        if (graficoCustoTiposMultaAnual) graficoCustoTiposMultaAnual.dispose();
        if (graficoCustoMultaAnual) graficoCustoMultaAnual.dispose();
        if (graficoCustoMultaTipo) graficoCustoMultaTipo.dispose();
        if (graficoCustoReativoTipoMulta) graficoCustoReativoTipoMulta.dispose();
        if (graficoCustoAcumuladoAnualMultasPorUC) graficoCustoAcumuladoAnualMultasPorUC.dispose();
    }

    function atualizarListaGraficoCustoMultaAnual() {
        const graficoCustoMultaAnualAtualizado = montarGraficoColumn({
            state,
            component: graficoCustoMultaAnual,
            nome: "graficoCustoMultaAnual",
            dados: listaGraficoCustoMulta,
            category: filtro.multas_ano_safra ? "ano_inicio_fim_safra" : "ano",
            value: "valor",
            titulo: `Custo Total de Multas por ${filtro.multas_ano_safra ? "Safra" : "Ano"} (R$)`,
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoCustoMultaAnual(graficoCustoMultaAnualAtualizado);
    }

    function atualizarListaGraficoCustoTiposMultaAnual() {
        const graficoCustoTiposMultaAnualAtualizado = montarGraficoClusteredColumnGrupo(
            state,
            graficoCustoTiposMultaAnual,
            "graficoCustoTiposMultaAnual",
            listaGraficoCustoTiposMulta,
            "Custo Total Por Tipo de Multa (R$)",
            "R$",
            ""
        );
        setGraficoCustoTiposMultaAnual(graficoCustoTiposMultaAnualAtualizado);
    }

    function atualizarListaGraficoCustoMultaAgrupado() {
        const graficoCustoMultaTipoAtualizado = montarGraficoPieAnual(
            state,
            graficoCustoMultaTipo,
            "graficoCustoMultaTipo",
            listaGraficoCustoMultaAgrupado,
            "Custo Geral por Tipo de Multa (R$)",
            "R$",
            ""
        );
        setGraficoCustoMultaTipo(graficoCustoMultaTipoAtualizado);
    }

    function atualizarListaGraficoCustoReativoTipoMulta() {
        const graficoCustoReativoTipoMultaAtualizado = montarGraficoPieAnual(
            state,
            graficoCustoReativoTipoMulta,
            "graficoCustoReativoTipoMulta",
            listarGraficoCustoReativoTipoMulta,
            "Custo de Multa de Reativo por Tipo (R$)",
            "R$",
            ""
        );
        setGraficoCustoReativoTipoMulta(graficoCustoReativoTipoMultaAtualizado);
    }

    function atualizarListaGraficoCustoAcumuladoAnualMultasPorUC() {
        const graficoCustoAcumuladoAnualMultasPorUCAtualizado = montarGraficoHorizontalBar({
            component: graficoCustoAcumuladoAnualMultasPorUC,
            chartDivId: "graficoCustoAcumuladoAnualMultasPorUC",
            category: "nome_unidade_consumidora",
            value: "valor",
            bullet: "valor",
            bulletPosition: "out",
            bulletColor: "#fff",
            lista: [...listaGraficoCustoMultaPorUnidade].sort((a, b) => a.valor - b.valor),
            titulo: `Custo de Multas Acumulado no ${filtro.multas_ano_safra ? "Período Safra" : "Ano"} por UC (R$)`,
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoCustoAcumuladoAnualMultasPorUC(graficoCustoAcumuladoAnualMultasPorUCAtualizado);
    }

    function bloquearScroll(e) {
        e.preventDefault();
    }

    function toggleScroll(bloquear) {
        if (bloquear) {
            document.body.style.overflowY = "hidden";
            window.addEventListener("wheel", bloquearScroll, { passive: false });
            window.addEventListener("touchmove", bloquearScroll, { passive: false });
        } else {
            document.body.style.overflowY = "auto";
            window.removeEventListener("wheel", bloquearScroll);
            window.removeEventListener("touchmove", bloquearScroll);
        }
    }

    async function handleExport({ graficosAtivos, quantidadeUCs }) {
        const ALTURA_MAX_CONTEUDO = 84;
        const condicaoGraficoPaginaInteira = quantidadeUCs > 20;
        const condicao3PorPagina = quantidadeUCs <= 7;
        const graficosPorPaginaEmFuncaoDeQuantidadeUCs = condicaoGraficoPaginaInteira ? 1 : condicao3PorPagina ? 3 : 2;

        setLoading(true);
        toggleScroll(true);
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.zoom = "0.70"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1200 - desconto + "px";
            } else {
                el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const calcularWidthTabela = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = "0.7rem";
                el.style.zoom = "0.60"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1500 - desconto + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
            }
        };

        const formatarGrafico = ({ el }) => {
            if (el) {
                el.style.marginTop = "0px";
                el.style.fontSize = "0.8rem";
                calcularWidthGrafico({ el });
                el.style.backgroundColor = "#30303d";
                el.style.overflowY = "hidden";
                const titulo = el.querySelectorAll("tspan");
                titulo.forEach((el, i) => {
                    if (el.textContent.includes("Multa")) {
                        el.style.marginTop = "3rem";
                        el.style.fontSize = "1.6rem";
                        el.style.fontWeight = "bold";
                        el.setAttribute("x", el.textContent.length * 4 + "px"); // centraliza no meio do SVG
                        el.setAttribute("text-anchor", "middle");
                    }
                });
            }
        };
        const formatarTabela = ({ el, heightCelula }) => {
            if (el) {
                calcularWidthTabela({ el });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.paddingTop = "50px";
                el.style.paddingBottom = "50px";
                el.style.borderCollapse = "collapse";
                el.style.border = "1px solid #666682";

                // Aplica bordas também às células (th, td)
                const celulas = el.querySelectorAll("th, td");
                celulas.forEach((celula) => {
                    if (heightCelula) {
                        celula.style.height = heightCelula;
                    }
                    celula.style.border = "1px solid #666682";
                    celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                    celula.style.textAlign = "left";

                    // Remove botões dentro do próprio td (fora da div filha)
                    celula.querySelectorAll("button").forEach((btn) => btn.remove());
                });
            }
        };
        const exibirTagOculta = ({ el, textAlign = "left", titulo = false }) => {
            if (el) {
                calcularWidthGrafico({ el, desconto: 20 });
                el.style.color = "#FFFFFF";
                el.style.fontSize = titulo ? "1.6rem" : "1rem";
                el.style.lineHeight = "1rem";
                el.style.fontWeight = "bold";
                el.style.backgroundColor = "#30303d";
                el.style.visibility = "visible";
                el.style.marginBottom = "0px";
                el.style.marginTop = "10px";
                el.style.padding = "5px";
                el.style.textAlign = textAlign;
            }
        };

        if (contentCardRef.current) {
            const alinhamentoVertical = quantidadeUCs > 10 ? "flex-start" : "center";

            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            // const tituloGraficoGeracaoAvaliacaoProducaoMensal = contentCardRef.current.querySelector("#tituloGraficoGeracaoAvaliacaoProducaoMensal");
            const graficoCustoMultaAnual = contentCardRef.current.querySelector("#graficoCustoMultaAnual");
            const tabelaGraficoCustoMultaAnual = contentCardRef.current.querySelector("#tabelaGraficoCustoMultaAnual");
            const periodoGraficoPizza = contentCardRef.current.querySelector("#periodoGraficoPizza");
            const graficoCustoMultaTipo = contentCardRef.current.querySelector("#graficoCustoMultaTipo");
            const graficoCustoReativoTipoMulta = contentCardRef.current.querySelector("#graficoCustoReativoTipoMulta");
            const periodoCustoAcumuladoAnualMultasPorUC = contentCardRef.current.querySelector("#periodoCustoAcumuladoAnualMultasPorUC");
            const tabelaCustoAcumuladoAnualMultasPorUC = contentCardRef.current.querySelector("#tabelaCustoAcumuladoAnualMultasPorUC");

            const qtdLinhasTabela = 58;

            // tituloGraficoGeracaoAvaliacaoProducaoMensal
            formatarGrafico({ el: graficoCustoMultaAnual });
            formatarTabela({ el: tabelaGraficoCustoMultaAnual });
            exibirTagOculta({ el: periodoGraficoPizza, textAlign: "center" });
            formatarGrafico({ el: graficoCustoMultaTipo });
            formatarGrafico({ el: graficoCustoReativoTipoMulta });
            exibirTagOculta({ el: periodoCustoAcumuladoAnualMultasPorUC, textAlign: "center", titulo: true });
            formatarTabela({ el: tabelaCustoAcumuladoAnualMultasPorUC, heightCelula: quantidadeUCs > qtdLinhasTabela ? "3rem" : null });

            function calcularAlturaGraficosUC({ condicaoUltrapassaPaginas, quantidadeUCs, quantidadeLimite }) {
                const paginasOcupadasMesmoGrafico = Math.ceil(quantidadeUCs / quantidadeLimite);

                let alturaGraficosUC = ALTURA_MAX_CONTEUDO / graficosPorPaginaEmFuncaoDeQuantidadeUCs;

                if (condicaoUltrapassaPaginas) {
                    let total = 0;

                    for (let i = 0; i < paginasOcupadasMesmoGrafico; i++) {
                        //na primeira pagina soma mais 4% pra compensar a falta do rodapé
                        if (i == 0) {
                            total += ALTURA_MAX_CONTEUDO + 4;
                        } else if (i > 0 && i < paginasOcupadasMesmoGrafico - 1) {
                            //se é pagina do meia conta 100%, pq não tem cabeçalho nem rodapé
                            total += ALTURA_MAX_CONTEUDO + 16;
                        } else if (i == paginasOcupadasMesmoGrafico - 1) {
                            //na última pagina soma mais 10% pra compensar a falta do cabeçalho
                            total += ALTURA_MAX_CONTEUDO + 10;
                        }
                    }

                    alturaGraficosUC = total;
                }

                return alturaGraficosUC;
            }

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD; max-height:fit-content;font-family: Arial, sans-serif;"><div style="width:100%; height:10%;">
                                           <img src="${base64Cabecalho}" width="100%" />
                                       </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:4%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                                   <img src="${base64Rodape}" width="100%" />
                                               </div>
                                           </div> `;

            // Captura o HTML com os estilos atualizados
            const htmlGraficoCustoMultaAnual =
                graficosAtivos.includes("graficoCustoMultaAnual") && graficoCustoMultaAnual
                    ? `<div style="width:100%; height:${
                          quantidadeUCs > 10 ? 42 : 28
                      }%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoCustoMultaAnual.outerHTML +
                      tabelaGraficoCustoMultaAnual.outerHTML +
                      "</div>"
                    : "";
            // Captura o HTML com os estilos atualizados
            const htmlGraficosPizza =
                graficosAtivos.includes("graficosPizza") && graficoCustoMultaTipo && graficoCustoReativoTipoMulta
                    ? `<div style="width:100%; height:${quantidadeUCs > 10 ? 42 : 28}%; margin-bottom:10px; background-color:#30303d">` +
                      `<div style="display:flex; flex-direction:row; align-items:center; height:10%; justify-content:center;">${periodoGraficoPizza.outerHTML}</div>` +
                      `<div style="display:flex; flex-direction:row; align-items:center; height:90%; justify-content:center; padding-left:8%;">${
                          graficoCustoMultaTipo.outerHTML + graficoCustoReativoTipoMulta.outerHTML
                      }</div>` +
                      "</div>"
                    : "";

            // // Captura o HTML com os estilos atualizados
            const htmlGraficoCustoAcumuladoAnualMultasPorUC =
                graficosAtivos.includes("graficoCustoAcumuladoAnualMultasPorUC") && tabelaCustoAcumuladoAnualMultasPorUC
                    ? `<div style="width:100%; height:${calcularAlturaGraficosUC({
                          condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                          quantidadeUCs,
                          quantidadeLimite: qtdLinhasTabela,
                      })}%; display:flex; flex-direction:column; align-items: center; justify-content:${alinhamentoVertical}; background-color:#30303d;">` +
                      periodoCustoAcumuladoAnualMultasPorUC.outerHTML +
                      tabelaCustoAcumuladoAnualMultasPorUC.outerHTML +
                      "</div>"
                    : "";

            const graficos = [
                { h: quantidadeUCs > 10 ? 42 : 28, el: htmlGraficoCustoMultaAnual },
                { h: quantidadeUCs > 10 ? 42 : 28, el: htmlGraficosPizza },
                {
                    h: calcularAlturaGraficosUC({
                        condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                        quantidadeUCs,
                        quantidadeLimite: qtdLinhasTabela,
                    }),
                    el: htmlGraficoCustoAcumuladoAnualMultasPorUC,
                },
            ].filter((g) => g.el);

            if (!graficos.length) {
                setLoading(false);
                toggleScroll(false);
                return;
            }

            const listaPaginas = [];
            for (const g of graficos) {
                if (!listaPaginas.length) {
                    listaPaginas.push({
                        indice: listaPaginas.length,
                        alturaAcumulada: g.h,
                        graficos: [g.el],
                    });
                } else {
                    const ultimaPaginaIncluida = listaPaginas[listaPaginas.length - 1];
                    if (ultimaPaginaIncluida.alturaAcumulada + g.h > ALTURA_MAX_CONTEUDO) {
                        listaPaginas.push({
                            indice: listaPaginas.length,
                            alturaAcumulada: g.h,
                            graficos: [g.el],
                        });
                    } else {
                        ultimaPaginaIncluida.alturaAcumulada += g.h;
                        ultimaPaginaIncluida.graficos.push(g.el);
                    }
                }
            }

            let html = "";

            listaPaginas.forEach((pagina) => {
                html += htmlCabecalho;
                pagina.graficos.forEach((grafico) => {
                    html += grafico;
                });
                if (pagina.alturaAcumulada < ALTURA_MAX_CONTEUDO) {
                    html += `<div style="width:100%; height:${ALTURA_MAX_CONTEUDO - pagina.alturaAcumulada}%"></div>`;
                }
                html += htmlRodape;
            });
            // Gera o relatório com o HTML atualizado
            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            toggleScroll(false);
            setLoading(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    const listaTabelaCustoTotalMultas = graficoCustoMultaAnual ? graficoCustoMultaAnual._data : [];
    const periodo = Object.keys(listaTabelaCustoTotalMultas[0] || {})[0];
    const quantidadeUCs = listaGraficoCustoMultaPorUnidade.length || 0;

    return (
        <div ref={contentCardRef}>
            {loading ? (
                <>
                    <Loading />
                    <div style={{ height: "100vh", width: "100%" }}></div>
                </>
            ) : null}
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <Row alignRight style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                title="Exportar"
                                type={"light"}
                                icon={"fa fa-file-export"}
                                event={() => {
                                    if (!filtro.id_cliente) {
                                        return setInfo("Selecione um cliente e clique em atualizar antes de exportar");
                                    }
                                    setModalExportacaoAberto(true);
                                }}
                            />
                        </Grid>
                    </Row>
                    {modalExportacaoAberto ? (
                        <ModalAlert handleClose={() => setModalExportacaoAberto(false)} visibility={loading ? "hidden" : "visible"}>
                            <ExportAnalise
                                quantidadeUCs={quantidadeUCs}
                                listaGraficosDisponiveis={["graficoCustoMultaAnual", "graficosPizza", "graficoCustoAcumuladoAnualMultasPorUC"]}
                            />
                        </ModalAlert>
                    ) : null}
                    <div id="graficoCustoMultaAnual" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                    <div
                        style={{
                            minWidth: "890px",
                        }}
                    >
                        <Table responsive id="tabelaGraficoCustoMultaAnual">
                            <THead>
                                <Tr>
                                    <Th width={200}></Th>
                                    {listaTabelaCustoTotalMultas.map((item) => (
                                        <Th alignCenter>{item[periodo]}</Th>
                                    ))}
                                </Tr>
                            </THead>
                            <TBody>
                                <Tr>
                                    <Td color="#fff">R$ Total</Td>
                                    {listaTabelaCustoTotalMultas.map((item) => (
                                        <Td key={item[periodo]} alignCenter color="#fff">
                                            {parseFloat(item.valor_fatura || 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                </Tr>
                                <Tr>
                                    <Td color="#fff">R$ Multa</Td>
                                    {listaTabelaCustoTotalMultas.map((item) => (
                                        <Td key={item[periodo]} alignCenter color="#fff">
                                            {parseFloat(item.valor || 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                </Tr>
                                <Tr>
                                    <Td color="#fff">Rel. %</Td>
                                    {listaTabelaCustoTotalMultas.map((item) => (
                                        <Td key={item[periodo]} alignCenter color="#fff">
                                            {parseFloat(item.valor_fatura > 0 ? (item.valor * 100) / item.valor_fatura : 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                            %
                                        </Td>
                                    ))}
                                </Tr>
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard
                style={{
                    color: "#fff",
                    padding: 8,
                }}
            >
                <ContentCardHeader style={{ backgroundColor: "#fff" }}>
                    <Row>
                        <Grid cols="6 4 3 2">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                <DatePicker
                                    variant="inline"
                                    openTo="year"
                                    views={["year", "month"]}
                                    label="De"
                                    autoOk
                                    value={
                                        filtro.competencia_inicial_comparativo_tipo_multa
                                            ? `${String(filtro.competencia_inicial_comparativo_tipo_multa).substring(0, 4)}/${String(
                                                  filtro.competencia_inicial_comparativo_tipo_multa
                                              ).substring(4, 6)}/01 12:00:00`
                                            : null
                                    }
                                    onChange={(value) => {
                                        setFiltro({
                                            ...filtro,
                                            competencia_inicial_comparativo_tipo_multa: value
                                                ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                : null,
                                        });
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid cols="6 4 3 2">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                <DatePicker
                                    variant="inline"
                                    openTo="year"
                                    views={["year", "month"]}
                                    label="Até"
                                    autoOk
                                    value={
                                        filtro.competencia_final_comparativo_tipo_multa
                                            ? `${String(filtro.competencia_final_comparativo_tipo_multa).substring(0, 4)}/${String(
                                                  filtro.competencia_final_comparativo_tipo_multa
                                              ).substring(4, 6)}/01 12:00:00`
                                            : null
                                    }
                                    onChange={(value) => {
                                        setFiltro({
                                            ...filtro,
                                            competencia_final_comparativo_tipo_multa: value
                                                ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                : null,
                                        });
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid cols="12 4 3 2" style={{ paddingTop: 10 }}>
                            <Button
                                text="Limpar Período"
                                type={"primary"}
                                icon={"fa fa-minus"}
                                event={() => {
                                    setFiltro({
                                        ...filtro,
                                        competencia_inicial_comparativo_tipo_multa: null,
                                        competencia_final_comparativo_tipo_multa: null,
                                    });
                                }}
                            />
                        </Grid>
                        <Grid cols="6 4 3 2" style={{ paddingTop: 10 }}>
                            <Button text="Analisar" type={"primary"} icon={"fa fa-sync"} event={listar} />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div id="graficosPizza">
                        <Row>
                            <div id="periodoGraficoPizza" style={{ visibility: "hidden" }}>
                                {"Período: "}
                                {filtro.competencia_inicial_comparativo_tipo_multa
                                    ? `${String(filtro.competencia_inicial_comparativo_tipo_multa).substring(4, 6)}/${String(
                                          filtro.competencia_inicial_comparativo_tipo_multa
                                      ).substring(0, 4)}`
                                    : "_________"}
                                {" à "}
                                {filtro.competencia_final_comparativo_tipo_multa
                                    ? `${String(filtro.competencia_final_comparativo_tipo_multa).substring(4, 6)}/${String(
                                          filtro.competencia_final_comparativo_tipo_multa
                                      ).substring(0, 4)}`
                                    : "_________"}
                            </div>
                        </Row>
                        <Row>
                            <Grid cols="12 6 6 6" style={{ display: "flex" }}>
                                <div id="graficoCustoMultaTipo" style={{ width: "100%", paddingBlock: 20, height: 430 }}></div>
                            </Grid>
                            <Grid cols="12 6 6 6" style={{ display: "flex" }}>
                                <div id="graficoCustoReativoTipoMulta" style={{ width: "100%", paddingBlock: 20, height: 400 }}></div>
                            </Grid>
                        </Row>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ padding: 8 }}>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", maxHeight: 400 }}>
                    <div id="periodoCustoAcumuladoAnualMultasPorUC" style={{ visibility: "hidden", display: "flex", justifyContent: "center" }}>
                        <h4>{`Custo Acumulado de Multas por UC em ${filtro.ano_multas} (R$)`}</h4>
                    </div>
                    {modalExportacaoAberto && (
                        <Table
                            responsive
                            id="tabelaCustoAcumuladoAnualMultasPorUC"
                            height={(listaGraficoCustoMultaPorUnidade || []).length * 50 < 400 ? 400 : listaGraficoCustoMultaPorUnidade.length * 50}
                        >
                            <THead>
                                <Tr>
                                    <Th>Unidade</Th>
                                    <Th></Th>
                                    <Th alignCenter>Valor (R$)</Th>
                                </Tr>
                            </THead>
                            <TBody>
                                {listaGraficoCustoMultaPorUnidade.map((item, i, array) => {
                                    const max = parseFloat(array[0].valor || 0); //o max é o valor do primeiro, que é o maior
                                    const barraPercentual = max > 0 ? (parseFloat(item.valor || 0) / max) * 100 : 0;

                                    // Intervalos de hue possíveis (neon azul/roxo/lilás + verde/amarelo fosforescente)
                                    const hueRanges = [
                                        [200, 300], // azul → roxo → lilás
                                        [70, 110], // verde-limão / amarelo-esverdeado fluorescente
                                    ];

                                    // Escolhe aleatoriamente um dos intervalos
                                    const [minHue, maxHue] = hueRanges[Math.floor(Math.random() * hueRanges.length)];
                                    const hue = minHue + Math.floor(Math.random() * (maxHue - minHue));

                                    const saturation = 90 + Math.floor(Math.random() * 10); // 90–100%
                                    const lightness = 60 + Math.floor(Math.random() * 20); // 60–80%

                                    const cor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

                                    return (
                                        <Tr key={item.nome_unidade_consumidora}>
                                            <Td color="#fff">{item.nome_unidade_consumidora}</Td>
                                            <Td width="40vw">
                                                <div style={{ backgroundColor: cor, width: barraPercentual + "%", height: 20 }}></div>
                                            </Td>
                                            <Td alignCenter color="#fff">
                                                R$ {adicionarPontosMilhar(parseFloat(item.valor || 0).toFixed(2))}
                                            </Td>
                                        </Tr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    )}
                    {!modalExportacaoAberto && (
                        <div
                            id="graficoCustoAcumuladoAnualMultasPorUC"
                            style={{
                                width: "100%",
                                minWidth: 900,
                                height: (listaGraficoCustoMultaPorUnidade || []).length * 50 < 400 ? 400 : listaGraficoCustoMultaPorUnidade.length * 50,
                            }}
                        ></div>
                    )}
                </ContentCardBody>
            </ContentCard>
        </div>
    );

    function ExportAnalise({ listaGraficosDisponiveis }) {
        const [graficosAtivos, setGraficosAtivos] = useState(listaGraficosDisponiveis);
        const todosMarcados = graficosAtivos.length === listaGraficosDisponiveis.length;
        const existeAlgumMarcado = !!graficosAtivos.length;

        return (
            <>
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Selecione os gráficos que deseja exportar</p>
                </div>
                <LabelAndCheckbox
                    style={{ color: todosMarcados ? "#c90028" : "#1454ff", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem", marginBottom: 25 }}
                    label={todosMarcados ? "Desmarcar Todos" : "Marcar Todos"}
                    onChange={(e) => setGraficosAtivos(todosMarcados ? [] : listaGraficosDisponiveis)}
                    value={todosMarcados}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoMultaAnualCheckbox"
                    label="Custo Total de Multas por Ano"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoCustoMultaAnual")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoCustoMultaAnual")
                                : [...graficosAtivos, "graficoCustoMultaAnual"]
                        )
                    }
                    value={graficosAtivos.includes("graficoCustoMultaAnual")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficosPizzaCheckbox"
                    label="Custo Geral por Tipo de Multa e Custo de Multa de Reativo por Tipo"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficosPizza") ? graficosAtivos.filter((grafico) => grafico !== "graficosPizza") : [...graficosAtivos, "graficosPizza"]
                        )
                    }
                    value={graficosAtivos.includes("graficosPizza")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoAcumuladoAnualMultasPorUCCheckbox"
                    label="Custo Acumulado Anual de Multas por UC (R$)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoCustoAcumuladoAnualMultasPorUC")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoCustoAcumuladoAnualMultasPorUC")
                                : [...graficosAtivos, "graficoCustoAcumuladoAnualMultasPorUC"]
                        )
                    }
                    value={graficosAtivos.includes("graficoCustoAcumuladoAnualMultasPorUC")}
                />
                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Exportar</span>}
                            type={"info"}
                            icon={"fas fa-check"}
                            event={async (e) => {
                                if (!existeAlgumMarcado) {
                                    return setInfo("Marque pelo menos um item para exportar");
                                }
                                await handleExport({ graficosAtivos, quantidadeUCs });
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>

                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            event={() => setModalExportacaoAberto(false)}
                        />
                    </Grid>
                </Row>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    filtro: state.analise.filtro,
    listaGraficoCustoTiposMulta: state.analise.listaGraficoCustoTiposMulta,
    listaGraficoCustoMulta: state.analise.listaGraficoCustoMulta,
    listaGraficoCustoMultaAgrupado: state.analise.listaGraficoCustoMultaAgrupado,
    listarGraficoCustoReativoTipoMulta: state.analise.listarGraficoCustoReativoTipoMulta,
    listaGraficoCustoMultaPorUnidade: state.analise.listaGraficoCustoMultaPorUnidade,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getListaGraficoCustoMultaAnual,
            getListaGraficoCustoTiposMultaAnual,
            getListaGraficoCustoMultaAgrupado,
            getListaGraficoCustoReativoTipoMulta,
            getListaGraficoCustoMultaPorUnidadeAcumuladoAno,
            gerarRelatorio,
            setFiltro,
        },
        dispatch
    );
const AnaliseMulta = connect(mapStateToProps, mapDispatchToProps)(analiseMulta);
export { AnaliseMulta };
